import React, { useState } from 'react';
import { apiBaseUrl } from '../../util/api';
import css from './ContactForm.module.css';

const ContactForm = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState('');

  const handleChange = e => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const isLoading = status === 'loading';
  const trimmedForm = {
    name: form.name.trim(),
    email: form.email.trim(),
    message: form.message.trim(),
  };
  const isFormIncomplete = !trimmedForm.name || !trimmedForm.email || !trimmedForm.message;

  const handleSubmit = async e => {
    e.preventDefault();

    if (isLoading) {
      return;
    }

    if (isFormIncomplete) {
      setStatus('error');
      setErrorMsg('Bitte füllen Sie alle Felder aus.');
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    try {
      const response = await fetch(`${apiBaseUrl()}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(trimmedForm),
      });

      if (response.ok) {
        setStatus('success');
        setForm({ name: '', email: '', message: '' });
      } else {
        const data = await response.json().catch(() => ({}));
        setErrorMsg(data.error || 'Ein Fehler ist aufgetreten.');
        setStatus('error');
      }
    } catch {
      setErrorMsg('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
      setStatus('error');
    }
  };

  const isDisabled = isLoading || isFormIncomplete;

  return (
    <div className={css.wrapper}>
      {/* <div className={css.root}> */}
      <p className={css.title}>Kontakt</p>

      {status === 'success' ? (
        <div className={css.success}>✓ Nachricht gesendet – wir melden uns bald!</div>
      ) : (
        <form className={css.form} onSubmit={handleSubmit} noValidate>
          <input
            className={css.input}
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Ihr Name"
            required
            disabled={isLoading}
          />

          <input
            className={css.input}
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Ihre E-Mail Adresse"
            required
            disabled={isLoading}
          />

          <textarea
            className={classNames(css.input, css.textarea)}
            name="message"
            value={form.message}
            onChange={handleChange}
            placeholder="Schreiben Sie Ihre Nachricht"
            required
            disabled={isLoading}
            rows={3}
          ></textarea>

          <button
            className={css.button}
            type="submit"
            disabled={isDisabled}
            aria-busy={isLoading}
          >
            {isLoading ? 'Senden...' : 'Nachricht Senden'}
          </button>
        </form>
      )}

      {status === 'error' && <p className={css.error}>{errorMsg}</p>}
      {/* </div> */}
    </div>
  );
};

// inline classNames helper (no extra dep needed)
const classNames = (...args) => args.filter(Boolean).join(' ');

export default ContactForm;
